<link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">

<div class="col-md-6">
    <h1 routerLink="/home" class="no-margin">

            <span style="color: #43425d; font-weight: 500; font-size: 20px">Moj radni sto
                <i style="font-size: 12px" class="fas fa-chevron-down"></i></span>
    </h1>
    <p style="color: gray;">Pregled zadataka po statusu rada</p>
</div>
<div class="col-6 pt-2 text-right">
    <div class="d-inline cursor"><span (click)="changeKanbanPreviewHandler('table')"><i
            class="fa fa-th"></i> Tabela</span>
    </div>
    <div class="d-inline cursor ml-2"><span (click)="changeKanbanPreviewHandler('list')"><i
            class="fa fa-list"></i> Lista</span>
    </div>
</div>

<div class="no-padding">
    <div class="kanban-filter col-md-12 col-lg-12 no-padding-left">

        <div class="input-group">
            <div class="input-group-prepend">
        <span>
       <button class="mr-1 ml-1"
               [matMenuTriggerFor]="menu"
               #menuTrigger="matMenuTrigger"
               mat-mini-fab color="warn"
               aria-label="Example icon button with a filter list icon">
      <mat-icon>filter_list</mat-icon>
    </button>




    <mat-menu #menu="matMenu" [overlapTrigger]="false">
    <span>
      <button [matMenuTriggerFor]="projectMenu" mat-menu-item>
        <mat-icon>work</mat-icon>
        <span>Projekti</span>
      </button>
      <button [matMenuTriggerFor]="deadlineMenu" mat-menu-item>
        <mat-icon>calendar_today</mat-icon>
        <span>Rok za izvršenje</span>
      </button>
      <button [matMenuTriggerFor]="taskTypeMenu" mat-menu-item>
        <mat-icon>videocam</mat-icon>
        <span>Tip zadatka</span>
      </button>
    </span>
</mat-menu></span>
            </div>
            <textarea [(ngModel)]="filters.title" rows="1"
                      (keyup)="sendDataToKanban()"
                      class="new-task-title form-control no-border no-padding-left"
                      id="taskTitle"
                      placeholder="Pretraga po naslovu zadatka"
            ></textarea>
        </div>


    </div>
    <div class="col-md-4 col-lg-4 clearfix"></div>
    <div *ngIf="showChips" class=" col-md-7 col-lg-7 col-xl-7 mb-2" style="padding-left: 23px">
        <div class="row">
            <mat-chip-label *ngIf="getCheckedType().length"> Tip:</mat-chip-label>
            <mat-chip-list #chipList>
                <mat-chip
                        *ngFor="let item of getCheckedType()"
                        (removed)="removeItem(item, taskTypes)"
                        [selectable]="selectable"
                        [removable]="removable"
                        color="primary"
                        class="badge badge-danger rounded-pill  ml-1">{{item.name}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                </mat-chip>
            </mat-chip-list>


            <mat-chip-label *ngIf="getCheckedDeadline().length"> Rok za izvršenje:</mat-chip-label>
            <mat-chip-list #chipList>
                <mat-chip
                        *ngFor="let item of getCheckedDeadline()"
                        (removed)="removeItem(item, dateRange)"
                        [selectable]="selectable"
                        [removable]="removable"
                        color="primary"
                        class="badge badge-danger rounded-pill  ml-1">{{item.name}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                </mat-chip>
            </mat-chip-list>

            <mat-chip-label *ngIf="getCheckedProjects().length"> Projekti:</mat-chip-label>

            <mat-chip
                    style="margin-top: 3px"
                    *ngFor="let item of getCheckedProjects()"
                    (removed)="removeItem(item,projects)"
                    [selectable]="selectable"
                    [removable]="removable"
                    color="primary"
                    class="badge badge-danger rounded-pill  ml-1">{{item.name}}
                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip>

        </div>


    </div>
    <div class="col-md-1 col-lg-1 col-xl-1 clearfix text-right px-0">
    </div>
    <div class="clearfix col-md-4 col-lg-4 col-xl-4"></div>
</div>


<mat-menu style="display: none" [overlapTrigger]="false" #deadlineMenu="matMenu">
    <div>
        <section class="example-section" style="max-height: 150px;overflow: auto">
  <span class="example-list-section">
  </span>
            <span class="example-list-section">
    <ul style="padding-left:15px" (click)="$event.stopPropagation()">
      <li *ngFor="let date of dateRange;let i = index">
    <mat-checkbox
            (change)="selected = i;valueChange($event);sendDataToKanban()"
            class="example-margin" [checked]="date.checked">{{date.name}}
    </mat-checkbox>
      </li>
    </ul>
  </span>
        </section>
    </div>
</mat-menu>


<mat-menu style="display: none" [overlapTrigger]="false" #taskTypeMenu="matMenu">
    <div>
        <section class="example-section" style="max-height: 150px;overflow: auto">
  <span class="example-list-section">
  </span>
            <span class="example-list-section">
    <ul style="padding-left:15px" (click)="$event.stopPropagation()">
      <li *ngFor="let type of taskTypes">
            <section class="example-section">
  <mat-checkbox [checked]="type.checked" (change)="type.checked =!type.checked;sendDataToKanban()"
                class="example-margin">{{type.name}}</mat-checkbox>
</section>
      </li>
    </ul>
  </span>
        </section>
    </div>
</mat-menu>


<mat-menu style="display: none" [overlapTrigger]="false" #projectMenu="matMenu">
    <div style="padding-left:15px" (click)="$event.stopPropagation()">
        <input (keyup)="filterProjects($event)"
               [(ngModel)]="searchText"
               class="form-control form-control-placeholdericon"
               placeholder="&#xe8b6; Pretraži"
               type="text"
               id="example13">
    </div>
    <div>
        <section class="example-section" style="max-height: 150px;overflow: auto">
  <span class="example-list-section">
  </span>
            <span class="example-list-section">
    <ul style="padding-left:15px" (click)="$event.stopPropagation()">
      <li *ngFor="let project of filteredProjects">
        <section class="example-section">
  <mat-checkbox [checked]="project.checked" (change)="project.checked=!project.checked;sendDataToKanban()"
                [value]="project.checked"
                class="example-margin">{{project.name}}</mat-checkbox>
</section>
      </li>
    </ul>
  </span>
        </section>
    </div>
</mat-menu>


